// extracted by mini-css-extract-plugin
export default {"StreamPage":"GameWithoutLiveStream_StreamPage__6FUml","LoadingState":"GameWithoutLiveStream_LoadingState__WsUIx","IsViewingStream":"GameWithoutLiveStream_IsViewingStream__1uMnq"};